import { baseApi } from "../baseApi";
export const settingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    savePassword: builder.mutation({
      query: (body) => {
        return {
          url: `/users/change_password.json?`,
          method: "POST",
          body: body,
        };
      },
    }),
    savePin: builder.mutation({
        query: (body) => {
          return {
            url: `/users/change_pincode.json?`,
            method: "POST",
            body: body,
          };
        },
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useSavePasswordMutation,
  useSavePinMutation,
} = settingsApi;
